import { trpc } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { pageSeo } from '@/lib/seo'
import { msg } from '@lingui/core/macro'
import { noop, useSuspenseQuery } from '@tanstack/react-query'

export const Route = createFileRoute('/_landing/terms-of-use')({
  // No locale in the key: the server resolves it per request from the `language` cookie
  // (`ctx.i18n.language`), so there is ONE cache entry per document and `changeLanguage` — which writes
  // that cookie and invalidates the cache — refetches it in the new language. Keeping the locale out of
  // the input is what lets this be an ordinary context route instead of a carve-out.
  context: () => ({ legalDocumentQueryOptions: trpc.legal.getDocument.queryOptions({ document: 'terms-of-use' }) }),
  loader: ({ context }) => {
    context.queryClient.query(context.legalDocumentQueryOptions).catch(noop)
  },
  head: (ctx) =>
    pageSeo(ctx, {
      path: '/terms-of-use',
      title: msg`Terms of use`,
      description: msg`The terms governing the use of D’Anchiano, the psychographic talent assessment platform of KNOWLEDGE TO DECIDE K2D, S.L.`,
    }),
  component: RouteComponent,
  pendingComponent: () => <div className="mx-auto max-w-4xl p-8" />,
})

function RouteComponent() {
  const { data } = useSuspenseQuery(Route.useRouteContext().legalDocumentQueryOptions)

  return (
    <article
      className="unreset-tailwind mx-auto max-w-4xl p-8 break-words"
      // Trusted first-party content: build-time, repo-authored markdown (server legal/content/*/*.md)
      // bundled via Vite `?raw` + rendered with `Bun.markdown` — there is no user-controlled input path.
      // react-doctor-disable-next-line react-doctor/dangerous-html-sink -- trusted build-time legal HTML
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  )
}
